<script setup lang="ts">
import useDashboard from '@/modules/dashboard/composables/useDashboard';
import { Squares2X2Icon, ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/outline';
import ButtonG from '@/modules/shared/components/ButtonComponent.vue';

const { dashboard, href } = useDashboard();
</script>

<template>
    <div class="flex flex-col w-full h-full max-w-[1120px]">
        <div class="flex justify-between w-full items-start">
            <div class="flex flex-col gap-1 justify-start">
                <p class="text-lg font-semibold text-gray-950">Your dashboard</p>
                <p class="text-gray-500 text-sm font-normal">Measure your team’s email activity and track KPIs</p>
            </div>

            <ButtonG class="my-auto" text="Open in Looker Studio" hierarcy="outline" :icon-trailing="ArrowTopRightOnSquareIcon" @click="href" />
        </div>
        <div class="h-full mt-6 rounded-t-lg border border-solid border-gray-200 bg-white shadow-default">
            <iframe v-if="dashboard.length" :src="dashboard[0].dashboard_embedded_url" class="h-full shadow rounded-t-lg" style="border: none" height="92%" width="100%" frameborder="0" />
            <div v-else class="flex h-full flex-col justify-center items-center">
                <div class="p-3.5 bg-indigo-100 rounded-full">
                    <Squares2X2Icon class="w-6 h-6 text-indigo-600" />
                </div>
                <p class="text-gray-900 text-base leading-6 font-medium pt-2">Your dashboard will be ready soon</p>
                <p class="text-gray-500 text-sm leading-5 w-2/5 text-center pt-1">
                    We’re loading your data and getting your metrics ready for you! If you have any questions or want an update, please get in touch.
                </p>
                <div class="p-6 flex justify-center">
                    <a href="mailto:evalocci@emailmeter.com" target="_blank" class="py-2.25 px-4 text-sm bg-indigo-500 text-white hover:bg-indigo-600 rounded-md"> Contact your Account Manager </a>
                </div>
            </div>
        </div>
    </div>
</template>
